import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

const Section = styled.section`
  padding: 0;
  margin: 0;
`;

export const Title = styled.h2`
  color: ${p => p.theme.colors.darkFont};
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
  margin: 0 auto 28px auto;
  max-width: ${p => p.theme.globalWidth};

  ${breakpoints.medium`
    font-size: 1.25rem;
    margin-bottom: 38px;
  `};

  ${breakpoints.large`
    font-size: 1.5625rem;
    margin-bottom: 51px;
  `};
`;

export const Content = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-weight: 500;
  max-width: ${p => (p.small ? p.theme.globalWidthSmall : p.theme.globalWidth)};
  margin: 0 auto;
`;

export default Section;
